import { DividerSchema } from '@/views/sports/components/Divider/styles/Divider.styles';

export const dividerStyles: DividerSchema = {
  boxWrapper: {
    borderBottom: ['1px dashed', null, 'none'],
    borderColor: 'blackAlpha.400',
    boxShadow: '0 1px rgba(255, 255, 255, .04)',
  },
};
